<p-popover #notificationsPopover [appendTo]="appendTo" [dt]="popoverDt">
    <ng-template #content *ngTemplateOutlet="notificationsTemplate">
    </ng-template>
</p-popover> 

<ng-template #notificationsTemplate>
    <div class="flex flex-col w-2xs">
        @if(notifications().length > 0) {
            @for (notification of notifications(); track $index; let last = $last) {
                <div [class]="{
                    'flex': true,
                    'items-center': true,
                    'min-h-[30px]': true,
                    'border-s-5': true,
                    'pl-2': true,
                    'pr-2': true,
                    'py-2': true,
                    'rounded-sm': true,
                    'hover:bg-gray-100': true,
                    'border-s-(--p-toast-info-background)': !notification.read,
                    'border-s-(--text-color-secondary)': notification.read,
                }">
                    <a (click)="markNotificationRead(notification)" class="no-underline cursor-pointer">
                        <span [class]="{
                            'text-sm': true,
                            'font-bold': !notification.read
                        }">
                            {{notification?.message?.data?.title}}
                        </span>
                    </a>
                    <p-button
                        icon="pi pi-times" 
                        (click)="deleteNotification(notification)"
                        [text]="true"
                        [rounded]="true" [plain]="true"
                        [severity]="'secondary'"
                        [size]="'small'">
                    </p-button>
                </div>
                
                @if (!last) {
                    <p-divider></p-divider>
                }
            }
        }
        @else {
            <div class="flex items-center justify-center min-h-[30px]">
                <span i18n>No notifications in current session.</span>
            </div>
        }
        
    </div>
</ng-template>